const loadingLabel = "Wczytuje dane";
const plPL = {
  loadingLabel
};
export {
  plPL as default,
  loadingLabel
};
